import {
    ProductAlertsQuery as SourceProductAlertsQuery
} from 'SourceQuery/ProductAlerts.query';
import { Field } from 'Util/Query';

/** @namespace PeggysagePwa/Query/ProductAlerts/Query */
export class ProductAlertsQuery extends SourceProductAlertsQuery {
    getProductAlertSubscribeGuestMutation(productId, type, email) {
        return new Field('productAlertSubscribe')
            .addArgument('productId', 'ID!', productId)
            .addArgument('type', 'String!', type)
            .addArgument('email', 'String', email);
    }

    getProductAlertUnsubscribeMutation(type, customerId, customerEmail, productId, hash) {
        return new Field('productAlertUnSubscribe')
            .addArgument('productId', 'ID', productId)
            .addArgument('type', 'String!', type)
            .addArgument('customerId', 'Int', customerId)
            .addArgument('customerEmail', 'String', customerEmail)
            .addArgument('hash', 'String!', hash);
    }
}

export default new ProductAlertsQuery();
